<template>
  <Posts :object="object" :params="params" />
</template>

<script>
import {defineComponent, reactive} from "vue"
import Posts from "@/modules/post/pages/posts/components/posts/Posts"
import Drafts from "@/modules/post/pages/posts/services/Drafts"
import {useRoute} from "vue-router"

export default defineComponent({
  name: "PostsDrafts",
  components: {
    Posts
  },
  setup() {
    const route = useRoute()

    let object = new Drafts()

    let paramsQuery = reactive({
      channelId: parseInt(route.params["channel_id"]),
    })

    let params = {
      title: "Все черновики постов",
      h1: "Черновики постов",
      page: "posts_drafts",
      type_ids: [1, 5, 6, 7, 8, 9, 10, 12, 13, 14],
      channel_id: getChannelId(),
    }

    function getChannelId() {
      return paramsQuery.channelId
    }

    return {
      object,
      params,
    }
  }
})
</script>

<style scoped>

</style>
